import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import { Button, ButtonType } from '../Button';
import { Modal } from '../Modal';

// Angular source: apps/angular/src/js/ng/parent/bookings/booking-frequency/booking-frequency.tpl.html#no-relationship-modal
// Shown when a parent selects "recurring" for a caregiver they've never booked
// or messaged before — nudges them to message first.
interface Props {
  isOpen: boolean;
  onClose: () => void;
  sitterFirstName?: string;
  onMessage: () => void;
  onContinue: () => void;
}

export const NoRelationshipModal = ({
  isOpen,
  onClose,
  sitterFirstName,
  onMessage,
  onContinue,
}: Props): JSX.Element => (
  <Modal isOpen={isOpen} onClose={onClose} className='w-full max-w-lg'>
    <Button
      aria-label='Close'
      onClick={onClose}
      className='absolute right-2 top-2 text-gray-400 hover:text-gray-500 transition-colors'
    >
      <FontAwesomeIcon icon={faXmark} className='w-5 h-5' />
    </Button>
    <h2 className='font-semibold mb-3'>
      Have you spoken with {sitterFirstName ?? 'this caregiver'} yet?
    </h2>
    <p className='mb-5'>
      Caregivers tell us that they appreciate a quick note. Recurring bookings
      can be a big commitment, so it&rsquo;s important to ensure you&rsquo;re a
      good fit.
    </p>
    <div className='text-center space-x-2'>
      <Button buttonType={ButtonType.primary} onClick={onMessage}>
        Message
      </Button>
      <Button buttonType={ButtonType.secondary} onClick={onContinue}>
        Continue to Booking
      </Button>
    </div>
  </Modal>
);
